import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface OrganizationMember {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
}

export interface Organization {
  id: string;
  name: string;
  type: string;
  employees: number;
  projects: number;
  subscription: string;
  createdAt: string;
  members: OrganizationMember[];
  break?: {
    _id: string;
    hours: number;
  };
  handbook?: string;
  overtimeAllowed: boolean;
  overtimeHours: number;
  isDeleted?: boolean;
}

export interface Pagination {
  total: number;
  page: number;
  limit: number;
  pages: number;
}

export interface OrganizationsResponse {
  organizations: Organization[];
  pagination: Pagination;
}

const fetchOrganizations = async (
  page?: number,
  limit?: number
): Promise<OrganizationsResponse> => {
  const { data } = await customAxios.get<OrganizationsResponse>(
    "/super-admin/organizations",
    {
      params: { page, limit },
    }
  );
  return data;
};

export const useGetOrganizations = (page?: number, limit?: number) =>
  useQuery<OrganizationsResponse, AxiosError>(
    ["organizations", { page, limit }],
    () => fetchOrganizations(page, limit),
    {
      onError: (error) =>
        showNotification({
          title: "Error Loading Organizations",
          message:
            (error.response?.data as { message?: string })?.message ??
            "Failed to load organizations",
          color: "red",
        }),
      retry: 1,
      refetchOnMount: "always",
    }
  );
